//パラメーター引継ぎ
$(function() {
  const params = window.location.search;
  if (!params) return;

  $('.add_param').each(function () {
    const href = $(this).attr('href');
    const separator = href.indexOf('?') === -1 ? '?' : '&';
    $(this).attr('href', href + separator + params.replace('?', ''));
  });
}); 
